module.exports = __webpack_public_path__ + "img/procedure.9b5fd826.svg";